import { useAnalytics } from '@axo/shared/services/analytics';
import { useState } from 'react';

export const useDuplicateApplication = (legacyUrl?: string) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { track } = useAnalytics();

  const validate = async (ssn: string) => {
    if (!legacyUrl) throw new Error('Missing legacy url');

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('traffic') === 'internal') return false;

    try {
      const { hasActive: isDuplicated } = await fetch(
        `${legacyUrl}/has-active-application?ssn=${ssn}`
      ).then((res) => res.json());

      if (isDuplicated) {
        await track({ event: 'Application Duplicate Warned' });
        setIsModalOpen(true);
        return 'SocialSecurityNumber.error.duplicated';
      }
    } catch (error) {
      if (error instanceof Error)
        console.error(
          `Failed to check duplicated application: ${error.message}`
        );
    }
  };

  return {
    isModalOpen,
    setIsModalOpen,
    validate,
  };
};
